__turbopack_context__.v({
  "divider": "DiagnosticsSignalMarquee-module__H979oW__divider",
  "label": "DiagnosticsSignalMarquee-module__H979oW__label",
  "measureRow": "DiagnosticsSignalMarquee-module__H979oW__measureRow",
  "pill": "DiagnosticsSignalMarquee-module__H979oW__pill",
  "strip": "DiagnosticsSignalMarquee-module__H979oW__strip",
  "visuallyHidden": "DiagnosticsSignalMarquee-module__H979oW__visuallyHidden",
});
